import React, { useState, useEffect } from "react";

const IntervalCounter = (props) => {
  const [counter, setCounter] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCounter((counter) => counter + 3);
    }, 30000);
    return () => {
      clearInterval(interval);
      setCounter(0);
      
    };
  }, []);

  useEffect(() => {
    if (props.callbackHandler) {
      props.callbackHandler(counter);
    }
  }, [counter]);

  return <span></span>;
};

export default IntervalCounter;
